import { PublicInfoPage } from "@/pages/PublicInfoPage";
import { privacyLegalContent } from "@/pages/legalDocuments";

export function PrivacyPage() {
  return (
    <PublicInfoPage
      canonicalPath="/privacy"
      description="Learn how Liminl collects and uses personal information for accounts, onboarding, alumni matching, and introduction emails."
      documentTitle="Privacy Policy | Liminl"
      headingId="privacy-title"
      htmlContent={privacyLegalContent}
      navItems={[
        { href: "#who-we-are", label: "Who we are" },
        { href: "#information-we-collect", label: "Information we collect" },
        { href: "#how-we-use-information", label: "How we use it" },
        { href: "#how-we-share-information", label: "How we share" },
        { href: "#your-rights", label: "Your rights" },
        { href: "#data-security", label: "Data security" },
        { href: "#california-rights", label: "California rights" },
        { href: "#privacy-contact", label: "Contact" },
      ]}
      pageMeta="Effective 12 August 2026"
      title="Privacy Policy"
    />
  );
}
